module.exports = __webpack_public_path__ + "static/media/gif1.de723c2b.gif";